module.exports = __webpack_public_path__ + "static/media/total-customers.2f040c11.svg";